import React, { Component } from "react";
import axios from "axios";

export default function shareBpWrapper(WrappedComponent, { courseId, key, url: pageUrl }) {
  class ShareBp extends Component {
    componentDidMount() {
      this.sendShareBp();
    }
    sendShareBp = (optType = 0) => {
        const channelId = window.localStorage.getItem("channelId");
        const userId = window.localStorage.getItem("userId");
        const url = window.location.hostname.includes('aircourses')
        ?
        'https://bp.aircourses.com/bp/ac-share'
        :
        'http://192.168.10.209:8899/bp/ac-share'
        axios({
          url,
          method: 'post',
          data: {
            userId,
            courseId,
            channelId,
            key,
            url: pageUrl,
            optType,
            type: 3,
            remarktime: new Date().getTime(),
          }
        });
    };
    render() {
      return (
        <WrappedComponent {...this.props} sendShareBp={this.sendShareBp} />
      );
    }
  }
  return ShareBp;
}



// WEBPACK FOOTER //
// ./src/hoc/shareBp/index.js